<div class="login-title-section">
  <fgbcl-errors></fgbcl-errors>
</div>

<div class="form-group">
  <button
    (click)="loginTM()"
    class="btn text-white d-flex align-items-center justify-content-center btn-block login-button w-100"
  >
    <span class="font-size-14 fw-bold praktika-medium">{{ 'login.page.button' | translate }}</span>
    <img [src]="'logo/ticketmaster.svg' | contentAssetImage" class="tm-logo ps-2" />
  </button>
</div>
